import { Link } from 'react-router-dom';

export default function HeroSection() {
  const imageUrl = 'https://readdy.ai/api/search-image?query=Abstract%20modern%20composition%20with%20warm%20amber%20golden%20and%20soft%20terracotta%20tones%2C%20elegant%20flowing%20geometric%20shapes%20overlapping%20gracefully%2C%20subtle%20sophisticated%20gradients%2C%20minimalist%20artistic%20design%2C%20clean%20smooth%20curves%2C%20editorial%20background%20texture%20with%20gentle%20light%20diffusion%2C%20warm%20radiant%20glow%20from%20center%2C%20no%20text%2C%20refined%20premium%20aesthetic&width=1600&height=900&seq=vigorbuy-hero-2026-v3&orientation=landscape';
  return (
    <section className="relative min-h-[520px] md:min-h-[620px] flex items-center justify-center overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('${imageUrl}')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30" />

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-[800px] mx-auto text-center">
          <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-100/80 text-accent-800 text-xs font-medium mb-4 md:mb-6">
            <i className="ri-sparkling-line w-3.5 h-3.5 flex items-center justify-center"></i>
            <span>Updated for 2026</span>
          </div>

          <h1 className="text-3xl md:text-5xl lg:text-6xl font-bold font-heading text-white leading-tight mb-4 md:mb-6">
            VigorBuy Spreadsheet 2026
          </h1>

          <p className="text-sm md:text-base text-white/80 max-w-[600px] mx-auto mb-8 md:mb-10 leading-relaxed">
            Discover trusted spreadsheet resources, buying guides, QC tutorials, and expert tips
            to shop smarter with VigorBuy.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold whitespace-nowrap rounded-md bg-primary-500 text-background-50 hover:bg-primary-600 transition-all cursor-pointer"
            >
              VigorBuy Sheet
              <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-semibold whitespace-nowrap rounded-md bg-white/90 text-foreground-900 hover:bg-white transition-all cursor-pointer"
            >
              Buy It Now
              <i className="ri-shopping-cart-line w-4 h-4 flex items-center justify-center"></i>
            </a>
            <Link
              to="/vigorbuy-buying-guide/"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 text-sm font-medium whitespace-nowrap rounded-md border border-white/40 text-white hover:bg-white/10 transition-all cursor-pointer"
            >
              Shopping Guide
              <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}